export default __webpack_public_path__ + "static/media/bkg--enquire.2522d134.jpg";